import { useEffect } from 'react';

import { useAnalytics } from 'applications/GSP/shared/hooks/analytics';

import type { InspiredGlobalStudyPlatformApiModelsAccountGetAccountResponse as User } from 'applications/GSP/shared/api/gsp';

export const useAnalyticsIdentifyUser = (user: User | undefined) => {
  const analytics = useAnalytics();

  useEffect(() => {
    if (user?.id) {
      analytics.identify(user.id);
    }
  }, [analytics, user?.id]);
};
